export enum ImportMessageType {
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  DELETING = "DELETING",
  DELETED = "DELETED",
}
